/**
 * The `pricing_strategy` values stored on a ToE payment.
 *
 * Most strategies price each valuation in the breakdown table and the fee is the sum of
 * those rows. Two do not: DailyRatePerMember prices each team member, and LumpsumGeneral
 * is a single figure for the whole engagement.
 */
export enum PricingStrategy {
    LumpsumPerValuation = 1,
    PercentageBased = 2,
    SizeBased = 3,
    DailyRateCompany = 4,
    DailyRatePerMember = 5,
    LumpsumGeneral = 6
}

/** True when the fee is entered once rather than per row of the breakdown table. */
export function isSingleFeeStrategy(strategy: number): boolean {
    return strategy == PricingStrategy.LumpsumGeneral
}
